import { api } from "../../utils/api";
import { endpoints } from "../../utils/endpoints";
import { updateAudit } from "./auditSlice";

export const getCampaignAndinfluencersData = () => {
  return (dispatch, getState) => {
    api.getApiCall(
      endpoints.getUserAndCampainInsights,
      ``,
      (respData) => {
        dispatch(updateAudit({ graphData: respData.data.result }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};


export const getAllAuditListing = () => {
  return (dispatch, getState) => {
    const { limit, page } = getState().auditSlice;
    api.getApiCall(
      endpoints.getaudittrail,
      `?limit=${limit}&offset=${page * limit}`,
      (respData) => {
        dispatch(updateAudit({ listing: respData.data.result.data, totalCount: respData.data.result.count, totalPages: respData.data.result.count }));

      },
      (errors) => {
        console.log("error", errors);
      }
    );
  };
};